import React from 'react'
import useFormHooks from '../../Hooks/useFormHooks'
import { formDataToObject } from '../../utilities'
import Form from '../../wp-adons/Form'
import BaseInput from '../../wp-adons/Form/BaseInput'
export default function ContactForm ({ ...props }) {
  const { POST } = useFormHooks()

  return (
    <Form
      handleSubmit={async e => {
        e.preventDefault()
        const formData = new FormData(e.target)

        try {
          await POST('/wp-json/wp/v2/contact-list', {
            title: `new contact - ${formDataToObject(formData)?.first_name}${
              formDataToObject(formData)?.organization
                ? ` from - ${formDataToObject(formData)?.organization}`
                : ''
            }`,
            acf: {
              first_name: formDataToObject(formData)?.first_name,
              email: formDataToObject(formData)?.email,
              title: formDataToObject(formData)?.title,
              organization: formDataToObject(formData)?.organization,
              contact_date: formDataToObject(formData)?.contact_date
            },
          }).then(data => {
            e.target.reset()
          })
        } catch (error) {
          alert('There was an error submitting your form.')
        }
      }}
      className='form-wrapper text-color_light font-text_readable p-0'
      buttonClass='btn_white btn_md'
      {...props}
    >
      <BaseInput
        label='First Name'
        type='text'
        name='first_name'
        placeholder='Your first name goes here'
        className='placeholder-white'
        labelWrapperClass='border-b-color_light'
        required
      />
      <BaseInput
        label='Email'
        type='email'
        name='email'
        placeholder='A valid email goes here'
        className='placeholder-color_light'
        labelWrapperClass='border-b-color_light'
        required
      />
      <BaseInput
        label='Title'
        type='text'
        name='title'
        placeholder='Your title goes here'
        className='placeholder-color_light'
        labelWrapperClass='border-b-color_light'
        required
      />
      <BaseInput
        label='organization'
        type='text'
        name='organization'
        placeholder='Name of your organization goes here'
        labelWrapperClass='border-b-color_light'
        className='placeholder-color_light'
        defaultValue=''
      />
      <BaseInput
        label='Do you have a date in mind?'
        type='datetime-local'
        name='contact_date'
        placeholder='select date here'
        labelWrapperClass='border-b-color_light'
        required
      />
    </Form>
  )
}
